const SITE_ROOT = 'https://help.benchling.com';

export const TUTORIAL_ROUTES = {
  SITE_ROOT,
  ELN_ADDING_AUDITORS: 'https://help.benchling.com/hc/articles/9684260674189',
  REGISTRY_CREATING_NEW_DATA: 'https://help.benchling.com/hc/articles/9684264601997',
  REGISTRY_IMPORT_SPREADSHEETS: 'https://help.benchling.com/hc/articles/9684236189197',
  MOLBIO_SIMULATE_DIGEST: 'https://help.benchling.com/hc/articles/9684268012557',
  MOLBIO_MANUAL_PRIMER_DESIGN: 'https://help.benchling.com/hc/articles/9684251405837',
};
